// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import { 
//   Search, Eye, ShieldAlert, FileText, Calendar, CheckCircle2, 
//   XCircle, AlertCircle, CheckCircle, Loader2, Upload, 
//   Info
// } from 'lucide-react';
// import { FaArrowLeft } from 'react-icons/fa';
// import { toast } from 'react-toastify';
// import api from '../../common/apiClient';
// import PageLoader from '../../helpers/PageLoader';
// import FormOffCanvas from '../ui/FormOffCanvas';
// import SelectDropdown from '../../customStyles/SelectDropdown';
// import ModernTable from '../ui/ModernTable';
// import DeleteConfirmationOffcanvas from '../../helpers/DeleteConfirmationOffcanvas';
// import SummaryApi from '../../common/SummaryApi';

// // Onboarding status filter options
// const statusFilterOptions = [
//   { value: 'all', label: 'All Statuses' },
//   { value: 'personal_info_pending', label: 'Personal Info Pending' },
//   { value: 'documents_pending', label: 'Documents Pending' },
//   { value: 'signature_pending', label: 'Signature Pending' },
//   { value: 'background_verification', label: 'Background Verification' },
//   { value: 'hr_approval_pending', label: 'HR Approval Pending' },
//   { value: 'completed', label: 'Completed' },
//   { value: 'cancelled', label: 'Cancelled' }
// ];

// const OnboardingList = () => {
//   const { portalName } = useParams();
//   const navigate = useNavigate();
//   const [onboardings, setOnboardings] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Filters State
//   const [searchQuery, setSearchQuery] = useState('');
//   const [statusFilter, setStatusFilter] = useState('all');

//   // Detailed Checklist View Offcanvas States
//   const [isChecklistOpen, setIsChecklistOpen] = useState(false);
//   const [selectedOnboarding, setSelectedOnboarding] = useState(null);
//   const [documents, setDocuments] = useState([]);
//   const [loadingDocs, setLoadingDocs] = useState(false);
//   const [generatingDocId, setGeneratingDocId] = useState(null);
//   const [uploadingDocId, setUploadingDocId] = useState(null); // Tracks active file upload id

//   // Background Verification Offcanvas States
//   const [isBgvOpen, setIsBgvOpen] = useState(false);
//   const [bgvOnboardingId, setBgvOfferId] = useState(null);
//   const [bgvForm, setBgvForm] = useState({
//     status: 'passed',
//     vendor: '',
//     remarks: '',
//     reportUrl: ''
//   });
//   const [submittingBgv, setSubmittingBgv] = useState(false);

//   // HR Approval Offcanvas States
//   const [isApprovalOpen, setIsApprovalOpen] = useState(false);
//   const [approvalOnboardingId, setApprovalOnboardingId] = useState(null);
//   const [approvalForm, setApprovalForm] = useState({
//     decision: 'approved',
//     remarks: ''
//   });
//   const [submittingApproval, setSubmittingApproval] = useState(false);

//   // Cancel Onboarding Offcanvas States
//   const [selectedOnboardingToCancel, setSelectedOnboardingToCancel] = useState(null);
//   const [cancelReason, setCancelReason] = useState('');
//   const [isCancelling, setIsCancelling] = useState(false);

//   // Pagination State
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   // Fetch all onboarding candidates
//   const fetchOnboardings = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await api.get(SummaryApi.getAllOnboarding.url, {
//         params: { status: statusFilter === 'all' ? undefined : statusFilter }
//       });
//       if (response.data.success) {
//         setOnboardings(response.data.onboardings || []);
//       }
//     } catch (err) {
//       toast.error('Failed to load onboarding lifecycle list');
//     } finally {
//       setLoading(false);
//     }
//   }, [statusFilter]);

//   useEffect(() => {
//     fetchOnboardings();
//   }, [fetchOnboardings]);

//   // Load documents for detailed checklist view
//   const fetchOnboardingDocuments = async (onboardingId) => {
//     setLoadingDocs(true);
//     try {
//       const response = await api.get(SummaryApi.listDocuments.url(onboardingId));
//       if (response.data.success) {
//         setDocuments(response.data.documents || []);
//       }
//     } catch (err) {
//       toast.error('Failed to load mandatory documents list');
//     } finally {
//       setLoadingDocs(false);
//     }
//   };

//   // Open detailed checklist view
//   const handleOpenChecklist = async (row) => {
//     setSelectedOnboarding(row);
//     setIsChecklistOpen(true);
//     await fetchOnboardingDocuments(row._id);
//   };

//   // Generate unsigned PDF document
//   const handleGeneratePdf = async (docId) => {
//     setGeneratingDocId(docId);
//     try {
//       const response = await api.post(SummaryApi.generateDocument.url(docId), {
//         templateData: {
//           baseSalary: "360000", // Sample template configuration parameters
//           hra: "180000"
//         }
//       });
//       if (response.data.success) {
//         toast.success('Official PDF document generated successfully');
//         if (selectedOnboarding) {
//           fetchOnboardingDocuments(selectedOnboarding._id);
//         }
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Failed to generate document');
//     } finally {
//       setGeneratingDocId(null);
//     }
//   };

//   // 👈 Added: Native File Upload Handler for Signing and Uploading supporting documents
//   const handleUploadDocument = async (docId, file, type = 'supporting') => {
//     if (!file) return;
//     setUploadingDocId(docId);

//     const formData = new FormData();
//     try {
//       let response;
//       if (type === 'sign') {
//         formData.append('signedFile', file);
//         formData.append('signatureMethod', 'uploaded'); // Standard manual upload method
//         response = await api.post(SummaryApi.signDocument.url(docId), formData, {
//           headers: { 'Content-Type': 'multipart/form-data' }
//         });
//       } else {
//         formData.append('file', file);
//         response = await api.post(SummaryApi.uploadSupportingDocument.url(docId), formData, {
//           headers: { 'Content-Type': 'multipart/form-data' }
//         });
//       }

//       if (response.data.success) {
//         toast.success('Document uploaded successfully');
//         if (selectedOnboarding) {
//           fetchOnboardingDocuments(selectedOnboarding._id);
//         }
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Failed to upload document');
//     } finally {
//       setUploadingDocId(null);
//     }
//   };

//   // Open BGV form
//   const handleOpenBgv = (row) => {
//     setBgvOfferId(row._id);
//     setBgvForm({
//       status: row.backgroundVerification?.status || 'passed',
//       vendor: row.backgroundVerification?.vendor || '',
//       remarks: row.backgroundVerification?.remarks || '',
//       reportUrl: row.backgroundVerification?.reportUrl || ''
//     });
//     setIsBgvOpen(true);
//   };

//   // Submit BGV details
//   const handleBgvSubmit = async (e) => {
//     e.preventDefault();
//     setSubmittingBgv(true);
//     try {
//       const response = await api.post(SummaryApi.updateBackgroundVerification.url(bgvOnboardingId), bgvForm);
//       if (response.data.success) {
//         toast.success('Background verification status updated');
//         setIsBgvOpen(false);
//         fetchOnboardings();
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Failed to update BGV');
//     } finally {
//       setSubmittingBgv(false);
//     }
//   };

//   // Open Approval Form
//   const handleOpenApproval = (row) => {
//     setApprovalOnboardingId(row._id);
//     setApprovalForm({ decision: 'approved', remarks: '' });
//     setIsApprovalOpen(true);
//   };

//   // Submit HR final decision
//   const handleApprovalSubmit = async (e) => {
//     e.preventDefault();
//     setSubmittingApproval(true);
//     try {
//       const response = await api.post(SummaryApi.approvalOnboarding.url(approvalOnboardingId), approvalForm);
//       if (response.data.success) {
//         toast.success(approvalForm.decision === 'approved' ? 'Onboarding approved! Employee account created.' : 'Onboarding rejected.');
//         setIsApprovalOpen(false);
//         fetchOnboardings();
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Approval processing failed');
//     } finally {
//       setSubmittingApproval(false);
//     }
//   };

//   // Trigger Cancel Onboarding process
//   const handleCancelConfirm = async () => {
//     if (!selectedOnboardingToCancel) return;
//     setIsCancelling(true);
//     try {
//       const response = await api.post(SummaryApi.cancelOnboarding.url(selectedOnboardingToCancel._id), {
//         reason: cancelReason
//       });
//       if (response.data.success) {
//         toast.success('Onboarding process cancelled successfully');
//         setSelectedOnboardingToCancel(null);
//         fetchOnboardings();
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Failed to cancel onboarding');
//     } finally {
//       setIsCancelling(false);
//     }
//   };

//   const getStatusBadgeClass = (status) => {
//     switch (status) {
//       case 'personal_info_pending': return 'bg-yellow-50 text-yellow-700 border-yellow-200';
//       case 'documents_pending': return 'bg-blue-50 text-secondary border-blue-200';
//       case 'signature_pending': return 'bg-indigo-50 text-indigo-700 border-indigo-200';
//       case 'background_verification': return 'bg-purple-50 text-purple-700 border-purple-200';
//       case 'hr_approval_pending': return 'bg-amber-50 text-amber-700 border-amber-200';
//       case 'completed': return 'bg-green-50 text-green-700 border-green-200';
//       case 'cancelled': return 'bg-red-50 text-primary border-red-200';
//       default: return 'bg-gray-100 text-gray-600 border-gray-200';
//     }
//   };

//   // Filter and Search logic
//   const filteredOnboardings = useMemo(() => {
//     return onboardings.filter(item => {
//       const candidateName = `${item.candidateId?.firstName || ''} ${item.candidateId?.lastName || ''}`.toLowerCase();
//       const onbId = (item.onboardingId || '').toLowerCase();
//       const matchesSearch = candidateName.includes(searchQuery.toLowerCase()) || onbId.includes(searchQuery.toLowerCase());
//       return matchesSearch;
//     });
//   }, [onboardings, searchQuery]);

//   const paginatedData = useMemo(() => {
//     if (itemsPerPage === 'All') return filteredOnboardings;
//     const start = (currentPage - 1) * Number(itemsPerPage);
//     return filteredOnboardings.slice(start, start + Number(itemsPerPage));
//   }, [filteredOnboardings, currentPage, itemsPerPage]);

//   // ModernTable Columns configuration
//   const columns = [
//     {
//       label: 'Onboarding ID',
//       key: 'onboardingId',
//       render: (row) => <span className="font-bold text-gray-900">{row.onboardingId || 'PENDING'}</span>
//     },
//     {
//       label: 'New Hire',
//       key: 'candidate',
//       render: (row) => (
//         <div className="flex flex-col min-w-[150px]">
//           <span className="font-bold text-gray-800 capitalize">{row.candidateId?.firstName} {row.candidateId?.lastName}</span>
//           <span className="text-[10px] text-gray-400 mt-0.5">{row.candidateId?.email}</span>
//         </div>
//       )
//     },
//     {
//       label: 'Department',
//       key: 'department',
//       render: (row) => <span className="font-semibold text-gray-700">{row.departmentId?.name || 'N/A'}</span>
//     },
//     {
//       label: 'Target Joining',
//       key: 'joiningDate',
//       render: (row) => (
//         <div className="flex items-center gap-1.5 text-gray-600 whitespace-nowrap">
//           <Calendar className="h-4 w-4 text-gray-400" />
//           <span>{new Date(row.joiningDate).toLocaleDateString('en-IN', { dateStyle: 'medium' })}</span>
//         </div>
//       )
//     },
//     {
//       label: 'Checklist Progress',
//       key: 'progress',
//       render: (row) => {
//         const sections = ['personalInfo', 'education', 'workExperience', 'bankDetails', 'address', 'emergencyContact'];
//         const completedCount = sections.filter(sec => row.sectionStatus?.[sec] === true).length;
//         return (
//           <div className="flex flex-col gap-1 min-w-[100px]">
//             <span className="font-bold text-gray-700">{completedCount} / 6 Complete</span>
//             <div className="w-full bg-gray-100 rounded-full h-1.5">
//               <div 
//                 className="bg-primary h-1.5 rounded-full transition-all" 
//                 style={{ width: `${(completedCount / 6) * 100}%` }}
//               ></div>
//             </div>
//           </div>
//         );
//       }
//     },
//     {
//       label: 'Status',
//       key: 'status',
//       render: (row) => (
//         <span className={`px-2.5 py-0.5 rounded-full text-[9px] font-bold uppercase border ${getStatusBadgeClass(row.status)}`}>
//           {row.status?.replace(/_/g, ' ')}
//         </span>
//       )
//     }
//   ];

//   // Dynamic Row actions list passed to `<ModernTable />` using standard RowAction model
//   const tableActions = [
//     {
//       label: 'View Checklist Details',
//       icon: <Eye className="h-4 w-4" />,
//       onClick: (row) => handleOpenChecklist(row)
//     },
//     {
//       label: 'Verify Background (BGV)',
//       icon: <ShieldAlert className="h-4 w-4 text-purple-600" />,
//       onClick: (row) => handleOpenBgv(row),
//       show: (row) => !['completed', 'cancelled'].includes(row.status)
//     },
//     {
//       label: 'Approve & Finalize Hire',
//       icon: <CheckCircle2 className="h-4 w-4 text-green-600" />,
//       onClick: (row) => handleOpenApproval(row),
//       show: (row) => row.status === 'hr_approval_pending'
//     },
//     {
//       label: 'Cancel Onboarding',
//       icon: <XCircle className="h-4 w-4 text-red-600" />,
//       onClick: (row) => { setSelectedOnboardingToCancel(row); setCancelReason(''); },
//       show: (row) => !['completed', 'cancelled'].includes(row.status),
//       danger: true
//     }
//   ];

//   if (loading) return <PageLoader />;

//   return (
//   <>
//     <div className="space-y-6">
      
//       {/* Header Panel */}
//       <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-white p-4 md:p-6 rounded-xl border border-gray-100 shadow-sm">
//         <div className="flex items-center gap-2">
//           <button 
//             onClick={() => navigate(`/${portalName}/hr/recruitment-management?tab=onboarding`)} 
//             className="rounded-lg bg-red-50 border border-red-100 text-textPrimary hover:text-primary p-2 transition-colors"
//           >
//             <FaArrowLeft className="w-4 h-4" />
//           </button>
//           <div>
//             <h1 className="text-lg sm:text-xl font-bold text-gray-900 leading-tight">Employee Onboarding Pipeline</h1>
//             <p className="text-xs text-gray-500 mt-1">Track documentation, personal profile checks, BGV reports, and finalize employee account activations.</p>
//           </div>
//         </div>
//       </div>

//       {/* Filter and Search Panel using SelectDropdown */}
//       <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm flex flex-col sm:flex-row gap-4 items-end sm:items-center">
//         <div className="relative flex-1 w-full">
//           <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
//           <input
//             type="text"
//             placeholder="Search candidate name or Onboarding ID..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500 outline-none text-sm bg-gray-50/50"
//           />
//         </div>
//         <div className="w-full sm:w-64">
//           <SelectDropdown
//             label="Filter by Status"
//             options={statusFilterOptions}
//             value={statusFilter}
//             onChange={setStatusFilter}
//             valueKey="value"
//             labelKey="label"
//             searchable={false}
//             zIndex={40}
//             multiple={false}
//           />
//         </div>
//       </div>

//       {/* Modern Table Representation */}
//       {filteredOnboardings.length > 0 ? (
//         <ModernTable
//           columns={columns}
//           data={paginatedData}
//           actions={tableActions}
//           selectable={false}
//           pagination={{
//             totalItems: filteredOnboardings.length,
//             itemsPerPage: itemsPerPage,
//             currentPage: currentPage,
//             onPageChange: setCurrentPage,
//             onItemsPerPageChange: (v) => { setItemsPerPage(v); setCurrentPage(1); }
//           }}
//         />
//       ) : (
//         /* Empty block representation */
//         <div className="bg-white border rounded-xl p-12 flex flex-col items-center justify-center text-center shadow-sm space-y-4">
//           <div className="p-3 bg-red-50 rounded-full text-primary border border-red-100">
//             <FileText className="h-8 w-8" />
//           </div>
//           <div>
//             <h3 className="font-bold text-gray-800 text-sm">No Onboarding Records</h3>
//             <p className="text-xs text-gray-400 mt-1">Accept issued job offers to automatically trigger and kickstart the digital onboarding pipeline.</p>
//           </div>
//         </div>
//       )}
//     </div>
//       {/* 👈 Detailed Onboarding Checklist & Document Generation Offcanvas View */}
//       <FormOffCanvas
//         isOpen={isChecklistOpen}
//         onClose={() => { setIsChecklistOpen(false); setSelectedOnboarding(null); }}
//         title="Checklist & Mandatory Documentation"
//       >
//         {selectedOnboarding && (
//           <div className="space-y-6 text-xs text-gray-700">
            
//             {/* New Hire Brief details */}
//             <div className="bg-gray-50 border p-4 rounded-xl space-y-1">
//               <span className="text-[9px] font-extrabold uppercase text-primary tracking-wider">Candidate Details</span>
//               <h3 className="text-sm font-bold text-gray-900 capitalize">{selectedOnboarding.candidateId?.firstName} {selectedOnboarding.candidateId?.lastName}</h3>
//               <p className="text-gray-500">ID: {selectedOnboarding.onboardingId || 'PENDING'}</p>
//             </div>

//             {/* Checklist items status matrix */}
//             <div className="space-y-3">
//               <h4 className="text-[10px] font-bold text-gray-400 uppercase tracking-wider border-b pb-1.5">Checks & Sections Status</h4>
//               <div className="grid grid-cols-2 gap-3">
//                 {['personalInfo', 'education', 'workExperience', 'bankDetails', 'address', 'emergencyContact'].map((sec) => {
//                   const isDone = selectedOnboarding.sectionStatus?.[sec] === true;
//                   return (
//                     <div key={sec} className="flex items-center justify-between bg-white border p-3 rounded-lg">
//                       <span className="font-bold text-gray-700 capitalize">{sec.replace(/([A-Z])/g, ' $1')}</span>
//                       {isDone ? (
//                         <CheckCircle className="h-4 w-4 text-green-500 shrink-0" />
//                       ) : (
//                         <AlertCircle className="h-4 w-4 text-amber-500 shrink-0 animate-pulse" />
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             {/* Document Generation & Native File Upload list panel */}
//             <div className="space-y-3 border-t pt-4">
//               <h4 className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Mandatory Digital Signing Documents</h4>
//               {loadingDocs ? (
//                 <div className="flex justify-center py-4"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
//               ) : documents.length > 0 ? (
//                 <div className="space-y-2">
//                   {documents.map((doc) => (
//                     <div key={doc._id} className="flex flex-col bg-white border p-3 rounded-lg hover:shadow-xs transition-all space-y-2">
//                       <div className="flex items-center justify-between">
//                         <div>
//                           <p className="font-bold text-gray-800">{doc.title}</p>
//                           <span className="text-[9px] font-semibold text-gray-400 uppercase">{doc.status}</span>
//                         </div>
                        
//                         {doc.status === 'pending' ? (
//                           <button 
//                             onClick={() => handleGeneratePdf(doc._id)}
//                             disabled={generatingDocId === doc._id}
//                             className="bg-secondary hover:bg-blue-900 text-white font-bold px-3 py-1.5 rounded text-[10px] flex items-center gap-1 transition-all"
//                           >
//                             {generatingDocId === doc._id && <Loader2 className="h-3 w-3 animate-spin" />}
//                             Generate PDF
//                           </button>
//                         ) : (
//                           <a 
//                             href={doc.signedFileUrl || doc.generatedFileUrl || doc.uploadedFileUrl} 
//                             target="_blank" 
//                             rel="noreferrer"
//                             className="text-primary hover:underline font-bold text-[10px] flex items-center gap-1"
//                           >
//                             <FileText className="h-3.5 w-3.5" /> View Doc
//                           </a>
//                         )}
//                       </div>

//                       {/* 👈 Added: Native File Upload action block for signing or uploading supporting credentials */}
//                       {doc.status !== 'signed' && (
//                         <div className="pt-2 border-t border-dashed flex items-center gap-2">
//                           {doc.isSignatureRequired ? (
//                             <label className="cursor-pointer bg-red-50 hover:bg-red-100 text-primary font-bold px-3 py-1.5 rounded text-[10px] flex items-center gap-1 transition-all border border-red-100">
//                               <Upload className="h-3 w-3" /> Upload Signed PDF
//                               <input 
//                                 type="file" 
//                                 accept=".pdf"
//                                 className="hidden" 
//                                 onChange={(e) => handleUploadDocument(doc._id, e.target.files[0], 'sign')}
//                                 disabled={uploadingDocId === doc._id}
//                               />
//                             </label>
//                           ) : (
//                             <label className="cursor-pointer bg-blue-50 hover:bg-blue-100 text-secondary font-bold px-3 py-1.5 rounded text-[10px] flex items-center gap-1 transition-all border border-blue-100">
//                               <Upload className="h-3 w-3" /> Upload Supporting Doc
//                               <input 
//                                 type="file" 
//                                 accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
//                                 className="hidden" 
//                                 onChange={(e) => handleUploadDocument(doc._id, e.target.files[0], 'supporting')}
//                                 disabled={uploadingDocId === doc._id}
//                               />
//                             </label>
//                           )}
//                           {uploadingDocId === doc._id && <Loader2 className="h-3.5 w-3.5 animate-spin text-primary" />}
//                         </div>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <p className="text-[10px] text-gray-400 italic">No mandatory documents stubbed out.</p>
//               )}
//             </div>

//           </div>
//         )}
//       </FormOffCanvas>

//       {/* Update Background Verification Offcanvas */}
//       <FormOffCanvas 
//         isOpen={isBgvOpen} 
//         onClose={() => setIsBgvOpen(false)} 
//         title="Background Verification Update"
//       >
//         <form onSubmit={handleBgvSubmit} className="space-y-4">
//           <SelectDropdown 
//             label="BGV Status *"
//             options={[
//               { value: 'passed', label: 'Passed / Verified' },
//               { value: 'failed', label: 'Failed / Discrepancy Found' },
//               { value: 'waived', label: 'Waived / Bypassed' },
//               { value: 'in_progress', label: 'In Progress / Processing' }
//             ]}
//             value={bgvForm.status}
//             onChange={(val) => setBgvForm(prev => ({ ...prev, status: val }))}
//             valueKey="value"
//             labelKey="label"
//             searchable={false}
//             zIndex={66}
//             multiple={false}
//           />
//           <div>
//             <label className="block text-xs font-bold text-gray-700 mb-1">BGV Screening Agency / Vendor Name</label>
//             <input 
//               type="text" 
//               value={bgvForm.vendor}
//               onChange={(e) => setBgvForm(prev => ({ ...prev, vendor: e.target.value }))}
//               placeholder="e.g. VerifyRight Screening Inc."
//               className="w-full border rounded-lg p-2.5 text-xs outline-none focus:ring-2 focus:ring-red-500 bg-white"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-bold text-gray-700 mb-1">Report PDF URL (If available)</label>
//             <input 
//               type="url" 
//               value={bgvForm.reportUrl}
//               onChange={(e) => setBgvForm(prev => ({ ...prev, reportUrl: e.target.value }))}
//               placeholder="https://cloudinary.com/..."
//               className="w-full border rounded-lg p-2.5 text-xs outline-none focus:ring-2 focus:ring-red-500 bg-white"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-bold text-gray-700 mb-1">Verification Remarks</label>
//             <textarea 
//               rows={3}
//               value={bgvForm.remarks}
//               onChange={(e) => setBgvForm(prev => ({ ...prev, remarks: e.target.value }))}
//               className="w-full border rounded-lg p-2.5 text-xs outline-none focus:ring-2 focus:ring-red-500"
//             />
//           </div>
//           <button 
//             type="submit" 
//             disabled={submittingBgv} 
//             className="w-full bg-primary hover:bg-red-700 text-white py-2.5 rounded-lg text-xs font-bold disabled:opacity-50 transition-all flex items-center justify-center gap-1.5"
//           >
//             {submittingBgv && <Loader2 className="h-4 w-4 animate-spin" />}
//             Save Verification Status
//           </button>
//         </form>
//       </FormOffCanvas>

//       {/* HR Approval & Account Finalization Offcanvas */}
//       <FormOffCanvas 
//         isOpen={isApprovalOpen} 
//         onClose={() => setIsApprovalOpen(false)} 
//         title="Finalize Hire & Approve Account"
//       >
//         <form onSubmit={handleApprovalSubmit} className="space-y-4">
//           <div className="bg-red-50/50 border border-red-100 p-3 rounded-lg text-[11px] text-red-800 font-semibold flex items-start gap-1.5">
//             <Info className="h-4 w-4 shrink-0 mt-0.5 text-primary" />
//             <span>Note: Approving this request will automatically conclude onboarding, update candidate status to 'Hired', and create their official Employee User Profile inside the system.</span>
//           </div>

//           <SelectDropdown 
//             label="Decision *"
//             options={[
//               { value: 'approved', label: 'Approve & Create Account' },
//               { value: 'rejected', label: 'Reject / Cancel Process' }
//             ]}
//             value={approvalForm.decision}
//             onChange={(val) => setApprovalForm(prev => ({ ...prev, decision: val }))}
//             valueKey="value"
//             labelKey="label"
//             searchable={false}
//             zIndex={66}
//             multiple={false}
//           />
//           <div>
//             <label className="block text-xs font-bold text-gray-700 mb-1">Remarks & Decision Comments</label>
//             <textarea 
//               rows={4}
//               value={approvalForm.remarks}
//               onChange={(e) => setApprovalForm(prev => ({ ...prev, remarks: e.target.value }))}
//               placeholder="Enter details regarding final sign-off..."
//               className="w-full border rounded-lg p-2.5 text-xs outline-none focus:ring-2 focus:ring-red-500"
//             />
//           </div>
//           <button 
//             type="submit" 
//             disabled={submittingApproval} 
//             className="w-full bg-primary hover:bg-red-700 text-white py-2.5 rounded-lg text-xs font-bold disabled:opacity-50 transition-all flex items-center justify-center gap-1.5"
//           >
//             {submittingApproval && <Loader2 className="h-4 w-4 animate-spin" />}
//             Register Final Sign-off
//           </button>
//         </form>
//       </FormOffCanvas>

//       {/* Onboarding Cancellation using custom DeleteConfirmationOffcanvas */}
//       <DeleteConfirmationOffcanvas
//         isOpen={!!selectedOnboardingToCancel}
//         onClose={() => setSelectedOnboardingToCancel(null)}
//         onConfirm={handleCancelConfirm}
//         title="Cancel Onboarding Process"
//         confirmButtonText="Cancel Onboarding"
//         isLoading={isCancelling}
//         customDescription={
//           selectedOnboardingToCancel ? (
//             <span>
//               Are you sure you want to permanently cancel the onboarding process for{" "}
//               <span className="font-bold text-gray-800">
//                 {selectedOnboardingToCancel.candidateId?.firstName} {selectedOnboardingToCancel.candidateId?.lastName}
//               </span>? This will deactivate their onboarding ID and stop further signing lifecycles.
//             </span>
//           ) : null
//         }
//       >
//         <div>
//           <label className="block text-xs font-bold text-gray-700 mb-1">Cancellation Reason *</label>
//           <textarea 
//             required 
//             rows={3}
//             value={cancelReason}
//             onChange={(e) => setCancelReason(e.target.value)}
//             placeholder="e.g. Documentation issues or candidate withdrew acceptance..."
//             className="w-full border rounded-lg p-2.5 text-xs outline-none focus:ring-2 focus:ring-red-500"
//           />
//         </div>
//       </DeleteConfirmationOffcanvas>

//     </>
//   );
// };

// export default OnboardingList;


// ─────────────────────────────────────────────────────────────────────────────
// FILE: src/components/HRComponents/OnboardingList.jsx
// ─────────────────────────────────────────────────────────────────────────────
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { 
  Search, Eye, ShieldAlert, FileText, Calendar, CheckCircle2, 
  XCircle, AlertCircle, CheckCircle, Loader2, Upload, Info, Edit, FileSearch
} from 'lucide-react';
import { FaArrowLeft } from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '../../common/apiClient';
import PageLoader from '../../helpers/PageLoader';
import FormOffCanvas from '../ui/FormOffCanvas';
import SelectDropdown from '../../customStyles/SelectDropdown';
import ModernTable from '../ui/ModernTable';
import DeleteConfirmationOffcanvas from '../../helpers/DeleteConfirmationOffcanvas';
import SummaryApi from '../../common/SummaryApi';

// Onboarding status filter options
const statusFilterOptions = [
  { value: 'all', label: 'All Statuses' },
  { value: 'personal_info_pending', label: 'Personal Info Pending' },
  { value: 'documents_pending', label: 'Documents Pending' },
  { value: 'signature_pending', label: 'Signature Pending' },
  { value: 'background_verification', label: 'Background Verification' },
  { value: 'hr_approval_pending', label: 'HR Approval Pending' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' }
];

const OnboardingList = () => {
  const { portalName } = useParams();
  const navigate = useNavigate();
  const [onboardings, setOnboardings] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filters State
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  // Detailed Checklist View Offcanvas States
  const [isChecklistOpen, setIsChecklistOpen] = useState(false);
  const [selectedOnboarding, setSelectedOnboarding] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [loadingDocs, setLoadingDocs] = useState(false);
  const [generatingDocId, setGeneratingDocId] = useState(null);
  const [uploadingDocId, setUploadingDocId] = useState(null); 

  // 👈 Dynamic Section Editing States (Allows HR to edit pending checklist items)
  const [isSectionEditOpen, setIsSectionEditOpen] = useState(false);
  const [editingSectionName, setEditingSectionName] = useState('');
  const [sectionFormData, setSectionFormData] = useState({});
  const [updatingSection, setUpdatingSection] = useState(false);

  // 👈 Document Preview Modal States (Allows checking before generation)
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewDocType, setPreviewDocType] = useState('');

  // Background Verification Offcanvas States
  const [isBgvOpen, setIsBgvOpen] = useState(false);
  const [bgvOnboardingId, setBgvOfferId] = useState(null);
  const [bgvForm, setBgvForm] = useState({
    status: 'passed',
    vendor: '',
    remarks: '',
    reportUrl: ''
  });
  const [submittingBgv, setSubmittingBgv] = useState(false);

  // HR Approval Offcanvas States
  const [isApprovalOpen, setIsApprovalOpen] = useState(false);
  const [approvalOnboardingId, setApprovalOnboardingId] = useState(null);
  const [approvalForm, setApprovalForm] = useState({
    decision: 'approved',
    remarks: ''
  });
  const [submittingApproval, setSubmittingApproval] = useState(false);

  // Cancel Onboarding Offcanvas States
  const [selectedOnboardingToCancel, setSelectedOnboardingToCancel] = useState(null);
  const [cancelReason, setCancelReason] = useState('');
  const [isCancelling, setIsCancelling] = useState(false);

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
const isLocked = ['completed', 'cancelled'].includes(selectedOnboarding?.status);
  // Fetch all onboarding candidates
  const fetchOnboardings = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(SummaryApi.getAllOnboarding.url, {
        params: { status: statusFilter === 'all' ? undefined : statusFilter }
      });
      if (response.data.success) {
        setOnboardings(response.data.onboardings || []);
      }
    } catch (err) {
      toast.error('Failed to load onboarding lifecycle list');
    } finally {
      setLoading(false);
    }
  }, [statusFilter]);

  useEffect(() => {
    fetchOnboardings();
  }, [fetchOnboardings]);

  // Load documents for detailed checklist view
  const fetchOnboardingDocuments = async (onboardingId) => {
    setLoadingDocs(true);
    try {
      const response = await api.get(SummaryApi.listDocuments.url(onboardingId));
      if (response.data.success) {
        setDocuments(response.data.documents || []);
      }
    } catch (err) {
      toast.error('Failed to load mandatory documents list');
    } finally {
      setLoadingDocs(false);
    }
  };

  // Open detailed checklist view
  const handleOpenChecklist = async (row) => {
    setSelectedOnboarding(row);
    setIsChecklistOpen(true);
    await fetchOnboardingDocuments(row._id);
  };

  // Generate unsigned PDF document
  const handleGeneratePdf = async (docId) => {
    setGeneratingDocId(docId);
    try {
      const response = await api.post(SummaryApi.generateDocument.url(docId), {
        templateData: {
          baseSalary: "360000", 
          hra: "180000"
        }
      });
      if (response.data.success) {
        toast.success('Official PDF document generated successfully');
        if (selectedOnboarding) {
          fetchOnboardingDocuments(selectedOnboarding._id);
        }
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to generate document');
    } finally {
      setGeneratingDocId(null);
    }
  };

  // Native File Upload Handler for Signing and Uploading supporting documents
  const handleUploadDocument = async (docId, file, type = 'supporting') => {
    if (!file) return;
    setUploadingDocId(docId);

    const formData = new FormData();
    try {
      let response;
      if (type === 'sign') {
        formData.append('signedFile', file);
        formData.append('signatureMethod', 'uploaded'); // Standard manual upload method
        response = await api.post(SummaryApi.signDocument.url(docId), formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      } else {
        formData.append('file', file);
        response = await api.post(SummaryApi.uploadSupportingDocument.url(docId), formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }

      if (response.data.success) {
        toast.success('Document uploaded successfully');
        if (selectedOnboarding) {
          fetchOnboardingDocuments(selectedOnboarding._id);
        }
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to upload document');
    } finally {
      setUploadingDocId(null);
    }
  };

  // 👈 Open Section Editor Form with existing values
  const handleOpenSectionEdit = (sectionName) => {
    setEditingSectionName(sectionName);
    const existingData = selectedOnboarding[sectionName] || {};
    
    // Structure empty structures based on section
    if (sectionName === 'bankDetails') {
      setSectionFormData({
        accountHolderName: existingData.accountHolderName || '',
        accountNumber: existingData.accountNumber || '',
        ifscCode: existingData.ifscCode || '',
        bankName: existingData.bankName || '',
        branch: existingData.branch || ''
      });
    } else if (sectionName === 'address') {
      setSectionFormData({
        country: existingData.country || '',
        state: existingData.state || '',
        city: existingData.city || '',
        street: existingData.street || '',
        postalCode: existingData.postalCode || ''
      });
    } else if (sectionName === 'emergencyContact') {
      setSectionFormData({
        name: existingData.name || '',
        relationship: existingData.relationship || '',
        mobile: existingData.mobile || ''
      });
    } else {
      setSectionFormData(existingData);
    }
    
    setIsSectionEditOpen(true);
  };

  // 👈 Submit updated Onboarding Section values using dynamic PUT API
  const handleSectionSubmit = async (e) => {
    e.preventDefault();
    setUpdatingSection(true);
    try {
      const response = await api.put(
        SummaryApi.updateOnboarding.url(selectedOnboarding._id, editingSectionName),
        sectionFormData
      );
      if (response.data.success) {
        toast.success('Onboarding checklist section updated successfully');
        setIsSectionEditOpen(false);
        // Refresh state
        setSelectedOnboarding(response.data.onboarding);
        fetchOnboardings();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Section update failed');
    } finally {
      setUpdatingSection(false);
    }
  };

  // Open BGV form
  const handleOpenBgv = (row) => {
    setBgvOfferId(row._id);
    setBgvForm({
      status: row.backgroundVerification?.status || 'passed',
      vendor: row.backgroundVerification?.vendor || '',
      remarks: row.backgroundVerification?.remarks || '',
      reportUrl: row.backgroundVerification?.reportUrl || ''
    });
    setIsBgvOpen(true);
  };

  // Submit BGV details
  const handleBgvSubmit = async (e) => {
    e.preventDefault();
    setSubmittingBgv(true);
    try {
      const response = await api.post(SummaryApi.updateBackgroundVerification.url(bgvOnboardingId), bgvForm);
      if (response.data.success) {
        toast.success('Background verification status updated');
        setIsBgvOpen(false);
        fetchOnboardings();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update BGV');
    } finally {
      setSubmittingBgv(false);
    }
  };

  // Open Approval Form
  const handleOpenApproval = (row) => {
    setApprovalOnboardingId(row._id);
    setApprovalForm({ decision: 'approved', remarks: '' });
    setIsApprovalOpen(true);
  };

  // Submit HR final decision
  const handleApprovalSubmit = async (e) => {
    e.preventDefault();
    setSubmittingApproval(true);
    try {
      const response = await api.post(SummaryApi.approvalOnboarding.url(approvalOnboardingId), approvalForm);
      if (response.data.success) {
        toast.success(approvalForm.decision === 'approved' ? 'Onboarding approved! Employee account created.' : 'Onboarding rejected.');
        setIsApprovalOpen(false);
        fetchOnboardings();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Approval processing failed');
    } finally {
      setSubmittingApproval(false);
    }
  };

  // Trigger Cancel Onboarding process
  const handleCancelConfirm = async () => {
    if (!selectedOnboardingToCancel) return;
    setIsCancelling(true);
    try {
      const response = await api.post(SummaryApi.cancelOnboarding.url(selectedOnboardingToCancel._id), {
        reason: cancelReason
      });
      if (response.data.success) {
        toast.success('Onboarding process cancelled successfully');
        setSelectedOnboardingToCancel(null);
        fetchOnboardings();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to cancel onboarding');
    } finally {
      setIsCancelling(false);
    }
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'personal_info_pending': return 'bg-yellow-50 text-yellow-700 border-yellow-200';
      case 'documents_pending': return 'bg-blue-50 text-secondary border-blue-200';
      case 'signature_pending': return 'bg-indigo-50 text-indigo-700 border-indigo-200';
      case 'background_verification': return 'bg-purple-50 text-purple-700 border-purple-200';
      case 'hr_approval_pending': return 'bg-amber-50 text-amber-700 border-amber-200';
      case 'completed': return 'bg-green-50 text-green-700 border-green-200';
      case 'cancelled': return 'bg-red-50 text-primary border-red-200';
      default: return 'bg-gray-100 text-gray-600 border-gray-200';
    }
  };

  // Filter and Search logic
  const filteredOnboardings = useMemo(() => {
    return onboardings.filter(item => {
      const candidateName = `${item.candidateId?.firstName || ''} ${item.candidateId?.lastName || ''}`.toLowerCase();
      const onbId = (item.onboardingId || '').toLowerCase();
      const matchesSearch = candidateName.includes(searchQuery.toLowerCase()) || onbId.includes(searchQuery.toLowerCase());
      return matchesSearch;
    });
  }, [onboardings, searchQuery]);

  const paginatedData = useMemo(() => {
    if (itemsPerPage === 'All') return filteredOnboardings;
    const start = (currentPage - 1) * Number(itemsPerPage);
    return filteredOnboardings.slice(start, start + Number(itemsPerPage));
  }, [filteredOnboardings, currentPage, itemsPerPage]);

  // ModernTable Columns configuration
  const columns = [
    {
      label: 'Onboarding ID',
      key: 'onboardingId',
      render: (row) => <span className="font-bold text-gray-900">{row.onboardingId || 'PENDING'}</span>
    },
    {
      label: 'New Hire',
      key: 'candidate',
      render: (row) => (
        <div className="flex flex-col min-w-[150px]">
          <span className="font-bold text-gray-800 capitalize">{row.candidateId?.firstName} {row.candidateId?.lastName}</span>
          <span className="text-[10px] text-gray-400 mt-0.5">{row.candidateId?.email}</span>
        </div>
      )
    },
    {
      label: 'Department',
      key: 'department',
      render: (row) => <span className="font-semibold text-gray-700">{row.departmentId?.name || 'N/A'}</span>
    },
    {
      label: 'Target Joining',
      key: 'joiningDate',
      render: (row) => (
        <div className="flex items-center gap-1.5 text-gray-600 whitespace-nowrap">
          <Calendar className="h-4 w-4 text-gray-400" />
          <span>{new Date(row.joiningDate).toLocaleDateString('en-IN', { dateStyle: 'medium' })}</span>
        </div>
      )
    },
    {
      label: 'Checklist Progress',
      key: 'progress',
      render: (row) => {
        const sections = ['personalInfo', 'education', 'workExperience', 'bankDetails', 'address', 'emergencyContact'];
        const completedCount = sections.filter(sec => row.sectionStatus?.[sec] === true).length;
        return (
          <div className="flex flex-col gap-1 min-w-[100px]">
            <span className="font-bold text-gray-700">{completedCount} / 6 Complete</span>
            <div className="w-full bg-gray-100 rounded-full h-1.5">
              <div 
                className="bg-primary h-1.5 rounded-full transition-all" 
                style={{ width: `${(completedCount / 6) * 100}%` }}
              ></div>
            </div>
          </div>
        );
      }
    },
    {
      label: 'Status',
      key: 'status',
      render: (row) => (
        <span className={`px-2.5 py-0.5 rounded-full text-[9px] font-bold uppercase border ${getStatusBadgeClass(row.status)}`}>
          {row.status?.replace(/_/g, ' ')}
        </span>
      )
    }
  ];

  // Dynamic Row actions list passed to `<ModernTable />` using standard RowAction model
  const tableActions = [
    {
      label: 'View Checklist Details',
      icon: <Eye className="h-4 w-4" />,
      onClick: (row) => handleOpenChecklist(row)
    },
    {
      label: 'Verify Background (BGV)',
      icon: <ShieldAlert className="h-4 w-4 text-purple-600" />,
      onClick: (row) => handleOpenBgv(row),
      show: (row) => !['completed', 'cancelled'].includes(row.status)
    },
    {
      label: 'Approve & Finalize Hire',
      icon: <CheckCircle2 className="h-4 w-4 text-green-600" />,
      onClick: (row) => handleOpenApproval(row),
      show: (row) => row.status === 'hr_approval_pending'
    },
    {
      label: 'Cancel Onboarding',
      icon: <XCircle className="h-4 w-4 text-red-600" />,
      onClick: (row) => { setSelectedOnboardingToCancel(row); setCancelReason(''); },
      show: (row) => !['completed', 'cancelled'].includes(row.status),
      danger: true
    }
  ];

  if (loading) return <PageLoader />;

  return (
  <>
    <div className="space-y-6">
      
      {/* Header Panel */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-white p-4 md:p-6 rounded-xl border border-gray-100 shadow-sm">
        <div className="flex items-center gap-2">
          <button 
            onClick={() => navigate(`/${portalName}/hr/recruitment-management?tab=onboarding`)} 
            className="rounded-lg bg-red-50 border border-red-100 text-textPrimary hover:text-primary p-2 transition-colors"
          >
            <FaArrowLeft className="w-4 h-4" />
          </button>
          <div>
            <h1 className="text-lg sm:text-xl font-bold text-gray-900 leading-tight">Employee Onboarding Pipeline</h1>
            <p className="text-xs text-gray-500 mt-1">Track documentation, personal profile checks, BGV reports, and finalize employee account activations.</p>
          </div>
        </div>
      </div>

      {/* Filter and Search Panel using SelectDropdown */}
      <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm flex flex-col sm:flex-row gap-4 items-end sm:items-center">
        <div className="relative flex-1 w-full">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
          <input
            type="text"
            placeholder="Search candidate name or Onboarding ID..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500 outline-none text-sm bg-gray-50/50"
          />
        </div>
        <div className="w-full sm:w-64">
          <SelectDropdown
            label="Filter by Status"
            options={statusFilterOptions}
            value={statusFilter}
            onChange={setStatusFilter}
            valueKey="value"
            labelKey="label"
            searchable={false}
            zIndex={40}
            multiple={false}
          />
        </div>
      </div>

      {/* Modern Table Representation */}
      {filteredOnboardings.length > 0 ? (
        <ModernTable
          columns={columns}
          data={paginatedData}
          actions={tableActions}
          selectable={false}
          pagination={{
            totalItems: filteredOnboardings.length,
            itemsPerPage: itemsPerPage,
            currentPage: currentPage,
            onPageChange: setCurrentPage,
            onItemsPerPageChange: (v) => { setItemsPerPage(v); setCurrentPage(1); }
          }}
        />
      ) : (
        /* Empty block representation */
        <div className="bg-white border rounded-xl p-12 flex flex-col items-center justify-center text-center shadow-sm space-y-4">
          <div className="p-3 bg-red-50 rounded-full text-primary border border-red-100">
            <FileText className="h-8 w-8" />
          </div>
          <div>
            <h3 className="font-bold text-gray-800 text-sm">No Onboarding Records</h3>
            <p className="text-xs text-gray-400 mt-1">Accept issued job offers to automatically trigger and kickstart the digital onboarding pipeline.</p>
          </div>
        </div>
      )}
    </div>

      {/* Detailed Onboarding Checklist & Document Generation Offcanvas View */}
      <FormOffCanvas
        isOpen={isChecklistOpen}
        onClose={() => { setIsChecklistOpen(false); setSelectedOnboarding(null); }}
        title="Checklist & Mandatory Documentation"
      >
        {selectedOnboarding && (
          <div className="space-y-6 text-xs text-gray-700">
            
            {/* New Hire Brief details */}
            <div className="bg-gray-50 border p-4 rounded-xl space-y-1">
              <span className="text-[9px] font-extrabold uppercase text-primary tracking-wider">Candidate Details</span>
              <h3 className="text-sm font-bold text-gray-900 capitalize">{selectedOnboarding.candidateId?.firstName} {selectedOnboarding.candidateId?.lastName}</h3>
              <p className="text-gray-500">ID: {selectedOnboarding.onboardingId || 'PENDING'}</p>
            </div>

            {/* Checklist items status matrix */}
            <div className="space-y-3">
              <h4 className="text-[10px] font-bold text-gray-400 uppercase tracking-wider border-b pb-1.5">Checks & Sections Status</h4>
              <div className="grid grid-cols-2 gap-3">
                {['personalInfo', 'education', 'workExperience', 'bankDetails', 'address', 'emergencyContact'].map((sec) => {
                  const isDone = selectedOnboarding.sectionStatus?.[sec] === true;
                  return (
                    <div 
                      key={sec} 
                      onClick={() => !isLocked && handleOpenSectionEdit(sec)} // 👈 Added: Clicking lets HR view/edit details!
                      className="flex items-center justify-between bg-white hover:bg-gray-50 border p-3 rounded-lg cursor-pointer transition-all hover:border-primary"
                    >
                      <span className="font-bold text-gray-700 capitalize flex items-center gap-1.5">
                        <Edit className="h-3.5 w-3.5 text-gray-400" />
                        {sec.replace(/([A-Z])/g, ' $1')}
                      </span>
                      {isDone ? (
                        <CheckCircle className="h-4 w-4 text-green-500 shrink-0" />
                      ) : (
                        <AlertCircle className="h-4 w-4 text-amber-500 shrink-0 animate-pulse" />
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Document Generation & Native File Upload list panel */}
            <div className="space-y-3 border-t pt-4">
              <h4 className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Mandatory Digital Signing Documents</h4>
              {loadingDocs ? (
                <div className="flex justify-center py-4"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
              ) : documents.length > 0 ? (
                <div className="space-y-2">
                  {documents.map((doc) => (
                    <div key={doc._id} className="flex flex-col bg-white border p-3 rounded-lg hover:shadow-xs transition-all space-y-2">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="font-bold text-gray-800">{doc.title}</p>
                          <span className="text-[9px] font-semibold text-gray-400 uppercase">{doc.status}</span>
                        </div>
                        
                        <div className="flex items-center gap-1.5">
                          {/* 👈 Added: Template Preview button (Allows checking before generation) */}
                          {!doc.generatedFileUrl && (
                            <button
                              onClick={() => { setPreviewDocType(doc.docType); setIsPreviewOpen(true); }}
                              className="p-1.5 border rounded hover:bg-gray-100 text-gray-500 transition-colors"
                              title="Preview Template Structure"
                            >
                              <FileSearch className="h-3.5 w-3.5" />
                            </button>
                          )}

                          {/* Render View Doc button if generatedFileUrl exists, regardless of signed status */}
                          {!doc.generatedFileUrl ? (
                            <button 
                              onClick={() => handleGeneratePdf(doc._id)}
                              disabled={generatingDocId === doc._id}
                              className="bg-secondary hover:bg-blue-900 text-white font-bold px-3 py-1.5 rounded text-[10px] flex items-center gap-1 transition-all"
                            >
                              {generatingDocId === doc._id && <Loader2 className="h-3 w-3 animate-spin" />}
                              Generate PDF
                            </button>
                          ) : (
                            <a 
                              href={doc.signedFileUrl || doc.generatedFileUrl || doc.uploadedFileUrl} 
                              target="_blank" 
                              rel="noreferrer"
                              className="text-primary hover:underline font-bold text-[10px] flex items-center gap-1"
                            >
                              <FileText className="h-3.5 w-3.5" /> View Doc
                            </a>
                          )}
                        </div>
                      </div>

                      {/* Dynamic File Upload action block for signing or uploading supporting credentials */}
                      {doc.generatedFileUrl && doc.status !== 'signed' && (
                        <div className="pt-2 border-t border-dashed flex items-center gap-2">
                          {doc.isSignatureRequired ? (
                            <label className="cursor-pointer bg-red-50 hover:bg-red-100 text-primary font-bold px-3 py-1.5 rounded text-[10px] flex items-center gap-1 transition-all border border-red-100">
                              <Upload className="h-3 w-3" /> Upload Signed PDF
                              <input 
                                type="file" 
                                accept=".pdf"
                                className="hidden" 
                                onChange={(e) => handleUploadDocument(doc._id, e.target.files[0], 'sign')}
                                disabled={uploadingDocId === doc._id}
                              />
                            </label>
                          ) : (
                            <label className="cursor-pointer bg-blue-50 hover:bg-blue-100 text-secondary font-bold px-3 py-1.5 rounded text-[10px] flex items-center gap-1 transition-all border border-blue-100">
                              <Upload className="h-3 w-3" /> Upload Supporting Doc
                              <input 
                                type="file" 
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                className="hidden" 
                                onChange={(e) => handleUploadDocument(doc._id, e.target.files[0], 'supporting')}
                                disabled={uploadingDocId === doc._id}
                              />
                            </label>
                          )}
                          {uploadingDocId === doc._id && <Loader2 className="h-3.5 w-3.5 animate-spin text-primary" />}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-[10px] text-gray-400 italic">No mandatory documents stubbed out.</p>
              )}
            </div>

          </div>
        )}
      </FormOffCanvas>

      {/* 👈 Dynamic Checklist Section Editor Offcanvas (PUT updates on sections) */}
      <FormOffCanvas
        isOpen={isSectionEditOpen}
        onClose={() => setIsSectionEditOpen(false)}
        title={`View/Edit ${editingSectionName.replace(/([A-Z])/g, ' $1')}`}
      >
        <form onSubmit={handleSectionSubmit} className="space-y-4">
          
          {/* Form fields rendered dynamically based on chosen Checklist section */}
          {editingSectionName === 'bankDetails' && (
            <div className="space-y-4">
              <div>
                <label className="block text-xs font-bold text-gray-700 mb-1">Account Holder Name *</label>
                <input required type="text" value={sectionFormData.accountHolderName} onChange={(e) => setSectionFormData({ ...sectionFormData, accountHolderName: e.target.value })} className="w-full border rounded-lg p-2.5 text-xs bg-white outline-none" />
              </div>
              <div>
                <label className="block text-xs font-bold text-gray-700 mb-1">Account Number *</label>
                <input required type="text" value={sectionFormData.accountNumber} onChange={(e) => setSectionFormData({ ...sectionFormData, accountNumber: e.target.value })} className="w-full border rounded-lg p-2.5 text-xs bg-white outline-none" />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1">Bank Name *</label>
                  <input required type="text" value={sectionFormData.bankName} onChange={(e) => setSectionFormData({ ...sectionFormData, bankName: e.target.value })} className="w-full border rounded-lg p-2.5 text-xs bg-white outline-none" />
                </div>
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1">IFSC Code *</label>
                  <input required type="text" value={sectionFormData.ifscCode} onChange={(e) => setSectionFormData({ ...sectionFormData, ifscCode: e.target.value })} className="w-full border rounded-lg p-2.5 text-xs bg-white outline-none" />
                </div>
              </div>
            </div>
          )}

          {editingSectionName === 'address' && (
            <div className="space-y-4">
              <div>
                <label className="block text-xs font-bold text-gray-700 mb-1">Street Address *</label>
                <input required type="text" value={sectionFormData.street} onChange={(e) => setSectionFormData({ ...sectionFormData, street: e.target.value })} className="w-full border rounded-lg p-2.5 text-xs bg-white outline-none" />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1">City *</label>
                  <input required type="text" value={sectionFormData.city} onChange={(e) => setSectionFormData({ ...sectionFormData, city: e.target.value })} className="w-full border rounded-lg p-2.5 text-xs bg-white outline-none" />
                </div>
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1">State *</label>
                  <input required type="text" value={sectionFormData.state} onChange={(e) => setSectionFormData({ ...sectionFormData, state: e.target.value })} className="w-full border rounded-lg p-2.5 text-xs bg-white outline-none" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1">Country *</label>
                  <input required type="text" value={sectionFormData.country} onChange={(e) => setSectionFormData({ ...sectionFormData, country: e.target.value })} className="w-full border rounded-lg p-2.5 text-xs bg-white outline-none" />
                </div>
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1">Postal Code *</label>
                  <input required type="text" value={sectionFormData.postalCode} onChange={(e) => setSectionFormData({ ...sectionFormData, postalCode: e.target.value })} className="w-full border rounded-lg p-2.5 text-xs bg-white outline-none" />
                </div>
              </div>
            </div>
          )}

          {editingSectionName === 'emergencyContact' && (
            <div className="space-y-4">
              <div>
                <label className="block text-xs font-bold text-gray-700 mb-1">Contact Person Name *</label>
                <input required type="text" value={sectionFormData.name} onChange={(e) => setSectionFormData({ ...sectionFormData, name: e.target.value })} className="w-full border rounded-lg p-2.5 text-xs bg-white outline-none" />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1">Relationship *</label>
                  <input required type="text" value={sectionFormData.relationship} onChange={(e) => setSectionFormData({ ...sectionFormData, relationship: e.target.value })} className="w-full border rounded-lg p-2.5 text-xs bg-white outline-none" />
                </div>
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1">Mobile No *</label>
                  <input required type="tel" value={sectionFormData.mobile} onChange={(e) => setSectionFormData({ ...sectionFormData, mobile: e.target.value })} className="w-full border rounded-lg p-2.5 text-xs bg-white outline-none" />
                </div>
              </div>
            </div>
          )}

          {/* Simple Fallback notification for unsupported inline edit sections */}
          {['personalInfo', 'education', 'workExperience'].includes(editingSectionName) && (
            <div className="space-y-4">
              <div className="bg-red-50 text-primary p-4 border rounded-xl text-xs font-semibold flex items-center gap-1.5">
                <AlertCircle className="h-4 w-4" />
                <span>This structural dataset section can be populated natively through Candidate Portal or viewed dynamically. To save custom changes, use JSON update scripts on Candidate profile.</span>
              </div>
            </div>
          )}

          {!['personalInfo', 'education', 'workExperience'].includes(editingSectionName) && (
            <button 
              type="submit" 
              disabled={updatingSection}
              className="w-full bg-primary hover:bg-red-700 text-white py-2.5 rounded-lg text-xs font-bold disabled:opacity-50 transition-all flex items-center justify-center gap-1.5"
            >
              {updatingSection && <Loader2 className="h-4 w-4 animate-spin" />}
              Save Section Updates
            </button>
          )}
        </form>
      </FormOffCanvas>

      {/* 👈 Dynamic Document Structure Preview Modal */}
      <FormOffCanvas
        isOpen={isPreviewOpen}
        onClose={() => { setIsPreviewOpen(false); setPreviewDocType(''); }}
        title="Document Template Preview"
      >
        {previewDocType && (
          <div className="space-y-4 text-xs text-gray-700">
            <div className="bg-amber-50 border-l-4 border-amber-500 p-3.5 rounded-r-lg text-amber-800 font-semibold flex items-start gap-1.5">
              <Info className="h-4 w-4 shrink-0 mt-0.5 text-amber-600" />
              <span>Below is a simulated HTML visual structure of the contract template prior to PDF generation.</span>
            </div>
            
            <div className="bg-white border rounded-xl p-5 font-mono space-y-4 text-[11px] overflow-y-auto max-h-[50vh]">
              {previewDocType === 'offer_letter' ? (
                <div className="space-y-3">
                  <p className="text-center font-bold text-sm">EMPLOYMENT OFFER LETTER</p>
                  <p>Date: [Issue Date]</p>
                  <p>Dear [Candidate Name],</p>
                  <p>Following our evaluations, we are pleased to offer you employment with our organization for the position of Software Engineer.</p>
                  <p>Total CTC (Annual): [CTC Parameters]</p>
                </div>
              ) : previewDocType === 'nda' ? (
                <div className="space-y-3">
                  <p className="text-center font-bold text-sm">NON-DISCLOSURE AGREEMENT (NDA)</p>
                  <p>This Agreement restricts candidate from leaking proprietary codes, parameters, and algorithms.</p>
                </div>
              ) : (
                <p className="italic text-gray-400 text-center">Unsigned template structure</p>
              )}
            </div>
          </div>
        )}
      </FormOffCanvas>

      {/* Update Background Verification Offcanvas */}
      <FormOffCanvas 
        isOpen={isBgvOpen} 
        onClose={() => setIsBgvOpen(false)} 
        title="Background Verification Update"
      >
        <form onSubmit={handleBgvSubmit} className="space-y-4">
          <SelectDropdown 
            label="BGV Status *"
            options={[
              { value: 'passed', label: 'Passed / Verified' },
              { value: 'failed', label: 'Failed / Discrepancy Found' },
              { value: 'waived', label: 'Waived / Bypassed' },
              { value: 'in_progress', label: 'In Progress / Processing' }
            ]}
            value={bgvForm.status}
            onChange={(val) => setBgvForm(prev => ({ ...prev, status: val }))}
            valueKey="value"
            labelKey="label"
            searchable={false}
            zIndex={66}
            multiple={false}
          />
          <div>
            <label className="block text-xs font-bold text-gray-700 mb-1">BGV Screening Agency / Vendor Name</label>
            <input 
              type="text" 
              value={bgvForm.vendor}
              onChange={(e) => setBgvForm(prev => ({ ...prev, vendor: e.target.value }))}
              placeholder="e.g. VerifyRight Screening Inc."
              className="w-full border rounded-lg p-2.5 text-xs outline-none focus:ring-2 focus:ring-red-500 bg-white"
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-700 mb-1">Report PDF URL (If available)</label>
            <input 
              type="url" 
              value={bgvForm.reportUrl}
              onChange={(e) => setBgvForm(prev => ({ ...prev, reportUrl: e.target.value }))}
              placeholder="https://cloudinary.com/..."
              className="w-full border rounded-lg p-2.5 text-xs outline-none focus:ring-2 focus:ring-red-500 bg-white"
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-700 mb-1">Verification Remarks</label>
            <textarea 
              rows={3}
              value={bgvForm.remarks}
              onChange={(e) => setBgvForm(prev => ({ ...prev, remarks: e.target.value }))}
              className="w-full border rounded-lg p-2.5 text-xs outline-none focus:ring-2 focus:ring-red-500"
            />
          </div>
          <button 
            type="submit" 
            disabled={submittingBgv} 
            className="w-full bg-primary hover:bg-red-700 text-white py-2.5 rounded-lg text-xs font-bold disabled:opacity-50 transition-all flex items-center justify-center gap-1.5"
          >
            {submittingBgv && <Loader2 className="h-4 w-4 animate-spin" />}
            Save Verification Status
          </button>
        </form>
      </FormOffCanvas>

      {/* HR Approval & Account Finalization Offcanvas */}
      <FormOffCanvas 
        isOpen={isApprovalOpen} 
        onClose={() => setIsApprovalOpen(false)} 
        title="Finalize Hire & Approve Account"
      >
        <form onSubmit={handleApprovalSubmit} className="space-y-4">
          <div className="bg-red-50/50 border border-red-100 p-3 rounded-lg text-[11px] text-red-800 font-semibold flex items-start gap-1.5">
            <Info className="h-4 w-4 shrink-0 mt-0.5 text-primary" />
            <span>Note: Approving this request will automatically conclude onboarding, update candidate status to 'Hired', and create their official Employee User Profile inside the system.</span>
          </div>

          <SelectDropdown 
            label="Decision *"
            options={[
              { value: 'approved', label: 'Approve & Create Account' },
              { value: 'rejected', label: 'Reject / Cancel Process' }
            ]}
            value={approvalForm.decision}
            onChange={(val) => setApprovalForm(prev => ({ ...prev, decision: val }))}
            valueKey="value"
            labelKey="label"
            searchable={false}
            zIndex={66}
            multiple={false}
          />
          <div>
            <label className="block text-xs font-bold text-gray-700 mb-1">Remarks & Decision Comments</label>
            <textarea 
              rows={4}
              value={approvalForm.remarks}
              onChange={(e) => setApprovalForm(prev => ({ ...prev, remarks: e.target.value }))} // Fixed: Safely updated to correct arrow syntax [27]
              placeholder="Enter details regarding final sign-off..."
              className="w-full border rounded-lg p-2.5 text-xs outline-none focus:ring-2 focus:ring-red-500"
            />
          </div>
          <button 
            type="submit" 
            disabled={submittingApproval} 
            className="w-full bg-primary hover:bg-red-700 text-white py-2.5 rounded-lg text-xs font-bold disabled:opacity-50 transition-all flex items-center justify-center gap-1.5"
          >
            {submittingApproval && <Loader2 className="h-4 w-4 animate-spin" />}
            Register Final Sign-off
          </button>
        </form>
      </FormOffCanvas>

      {/* Onboarding Cancellation using custom DeleteConfirmationOffcanvas */}
      <DeleteConfirmationOffcanvas
        isOpen={!!selectedOnboardingToCancel}
        onClose={() => setSelectedOnboardingToCancel(null)}
        onConfirm={handleCancelConfirm}
        title="Cancel Onboarding Process"
        confirmButtonText="Cancel Onboarding"
        isLoading={isCancelling}
        customDescription={
          selectedOnboardingToCancel ? (
            <span>
              Are you sure you want to permanently cancel the onboarding process for{" "}
              <span className="font-bold text-gray-800">
                {selectedOnboardingToCancel.candidateId?.firstName} {selectedOnboardingToCancel.candidateId?.lastName}
              </span>? This will deactivate their onboarding ID and stop further signing lifecycles.
            </span>
          ) : null
        }
      >
        <div>
          <label className="block text-xs font-bold text-gray-700 mb-1">Cancellation Reason *</label>
          <textarea 
            required 
            rows={3}
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
            placeholder="e.g. Documentation issues or candidate withdrew acceptance..."
            className="w-full border rounded-lg p-2.5 text-xs outline-none focus:ring-2 focus:ring-red-500"
          />
        </div>
      </DeleteConfirmationOffcanvas>

    </>
  );
};

export default OnboardingList;